import type { PublicPadFile } from "../shared";

export function createPadId() {
  const alphabet = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  const values = new Uint8Array(6);
  crypto.getRandomValues(values);

  return Array.from(values, (value) => alphabet[value % alphabet.length]).join("");
}

export function getTextStats(value: string) {
  const trimmed = value.trim();

  return {
    characters: value.length,
    words: trimmed ? trimmed.split(/\s+/).length : 0,
    lines: value ? value.split(/\r\n|\r|\n/).length : 0,
  };
}

export function isTextLike(file: PublicPadFile) {
  return (
    file.type.startsWith("text/") ||
    /\.(txt|md|json|js|ts|tsx|jsx|css|html|xml|csv|log|yaml|yml)$/i.test(file.name)
  );
}
